var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vueMain", [
    _c(
      "div",
      { attrs: { slot: "title" }, slot: "title" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { lg: "6" } }, [
              _c("span", { staticClass: "h3" }, [_vm._v("Test")])
            ]),
            _vm._v(" "),
            _c("b-col", { staticClass: "text-right", attrs: { lg: "6" } }, [
              _vm._v("Puedes poner html en el slot")
            ])
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "component component-test",
        attrs: { "data-trackname": "test" }
      },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { lg: "9" } }, [
              _c(
                "div",
                { staticClass: "component component-kpis" },
                [_c("Kpicontainer")],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "b-col",
              { attrs: { lg: "3" } },
              [
                _c(
                  "b-card",
                  [
                    _c("Donut", { attrs: { val: "70", units: "%" } }),
                    _vm._v(" "),
                    _c("h5", { staticClass: "donut_subtitle" }, [
                      _vm._v(_vm._s(_vm.$t("TestItems.table.title")))
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "b-card",
          { staticClass: "mt-4" },
          [
            _c(
              "div",
              { attrs: { slot: "header" }, slot: "header" },
              [
                _c("h3", [_vm._v(_vm._s(_vm.$t("TestItems.header")))]),
                _vm._v(" "),
                _c(
                  "b-btn",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.NewItemModal",
                        modifiers: { NewItemModal: true }
                      }
                    ],
                    staticClass: "card-header-button",
                    attrs: {
                      "data-trackname": "itemsListBtnNewItem",
                      variant: "primary"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("TestItems.new_item")) +
                        " "
                    ),
                    _c("i", { staticClass: "fa fa-plus" })
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("Table", {
              ref: "table",
              attrs: {
                columns: _vm.columns,
                url: "testitems/",
                options: _vm.options
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("NewItemModal", {
          attrs: { id: "myItemModal" },
          on: { newItem: _vm.refresh }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Test/Test.vue?vue&type=template&id=e63a9138&
// module id = null
// module chunks = 